;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('coreTableColumnRowText', tableColumnRowText)

  /* @ngInject */
  function tableColumnRowText () {
    return {
      restrict: 'E',
      scope: {
        value: '<',
        hasTitle: '<',
        positionLimit: '<',
        position: '<',
        textAlignment: '<'
      },
      templateUrl: '/core/directives/table-columns/table-column-row-text/table-column-row-text-directive.html?$$REVISION$$'
    }
  }
})()
